import TweetForm from "../TweetForm";

const AddTweet = () => {
    return <TweetForm />;
};

export default AddTweet;
